export default __webpack_public_path__ + "static/1797-6134e7e046c19a29a36922b10e10e43e.gif";